import React, { useState } from 'react';

const DialogContext = React.createContext({
  content: null,
  showDialog: false,
  // @ts-ignore
  openDialog: (content: any) => {},
  closeDialog: () => {},
});

export const DialogProvider = ({ children }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [content, setDialogContent] = useState(null);

  const openDialog = content => {
    setDialogContent(content);
    setShowDialog(true);
  };

  const closeDialog = () => setShowDialog(false);
  const contextValue = { openDialog, closeDialog };
  return (
    <DialogContext.Provider value={contextValue as any}>
      {children}
      {showDialog && content}
    </DialogContext.Provider>
  );
};

export const useDialog = () => {
  const context = React.useContext(DialogContext);
  if (context === undefined) {
    throw new Error('use Dialog must be used within a DialogProvider');
  }
  return context;
};
